import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Route, Switch } from 'react-router-dom';
import { ThemeSwitcherProvider } from "react-css-theme-switcher";
import { THEME_CONFIG } from './configs/AppConfig';
import ThemeBootstrap from "./components/layout-components/ThemeBootstrap";

const lightTheme = THEME_CONFIG.lightTheme || 'light-theme.css';
const darkTheme = THEME_CONFIG.darkTheme || 'dark-theme.css';


const themes = {
  dark: `${process.env.PUBLIC_URL}/css/${darkTheme}`,
  light: `${process.env.PUBLIC_URL}/css/${lightTheme}`,
};

function App() {
  return (
    <div className='App'>
      <Provider store={store}>
        <ThemeSwitcherProvider themeMap={themes} defaultTheme={THEME_CONFIG.currentTheme} insertionPoint="styles-insertion-point">
          <ThemeBootstrap>
            <Router>
              <Switch>
                <Route path="/" component={Views}/>
              </Switch>
            </Router>
          </ThemeBootstrap>
        </ThemeSwitcherProvider>
      </Provider>
    </div>
  );
}

export default App;
